<template>
  <i-layout>
    <i-layout-header>
      <the-header />
    </i-layout-header>

    <i-layout-content am-layout-content>
      <the-sidebar v-if="$route.fullPath !== '/'" />
      <router-view />
      <formulaModal v-if="$store.state.formula.isShowFormula" />
    </i-layout-content>

    <the-notifications />
  </i-layout>
</template>

<script>
import TheHeader from './components/TheHeader'
import TheSidebar from './components/TheSidebar'
import formulaModal from './components/formula/formulaModal'

import TheNotifications from './components/TheNotifications'

import { io } from 'socket.io-client'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheSidebar,
    TheNotifications,
    formulaModal
  },
  computed: mapState(['ui']),
  methods: {
    ...mapActions('parts', ['afterUpdatedParts']),
    ...mapMutations('ui', ['closeModal'])
  },
  created () {
    const socket = io(`wss://${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`, {
      reconnectionDelayMax: 10000
    })
    socket.on('part_updated', msg => {
      this.afterUpdatedParts({ id: msg.id, subtable: this.$route.params.subtable })
    })
    window.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') {
        if (this.ui.modalCloser === null) return
        this.ui.modalCloser()
        this.closeModal(null)
      }
    })
  }
}
</script>

<style lang="scss">
  html, body, #app, main {
    width: 100%;
    height: 100%;
    min-height: 100vh;
  }
  [am-layout-content] {
    position: relative;
    display: flex;
    flex-grow: 1;
    overflow: hidden;
  }
</style>
